__webpack_require__.p = "/assets-new/";